import { CircularProgress as MUICircularProgress } from '@mui/material';
import { useEffect, useRef } from 'react';

const CircularProgress = (props) => {
    const ref = useRef();

    useEffect(() => {
        const svgEl = ref.current.querySelector('svg');
        if (svgEl) svgEl.setAttribute('role', 'none');
    }, []);

    return <MUICircularProgress ref={ref} {...props} />;
};

export default CircularProgress;
